import React from 'react'
import SideArrowSvg from './Svg/SideArrowSvg'
import { SxProps } from '@mui/system'

interface Props {
  doNotFlow?: boolean
  directionIsReversed?: boolean
  sx?: SxProps
}

const SideArrow: React.FC<Props> = ({ doNotFlow, directionIsReversed, sx }) => {
  const direction = doNotFlow ? undefined : directionIsReversed ? 'out' : 'in'
  const transform = 'translateX(0)'
  const combinedSx = { width: 'fit-content', ...sx }
  return <SideArrowSvg transform={transform} sx={combinedSx} direction={direction} doRotateBy180Deg />
}

export default SideArrow
